import styled from 'styled-components';

const TitleHeader = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.fonts.fontFamilySecondary};
`;

export default TitleHeader;
